module.exports = __webpack_public_path__ + "img/ios-scan-img.c0b808af.png";